export const additem = async (newitem) => {
  const userToken = localStorage.getItem("user");
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/inventory/addnewitem",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(newitem),
      }
    );
    await response.json();
    window.location.reload();
  } catch (err) {
    console.log(err);
  }
};
export const deleteItem = async (id) => {
  const requestObject = {
    ID: id,
  };
  const userToken = localStorage.getItem("user");
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/inventory/deleteitem",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(requestObject),
      }
    );
    await response.text();
    window.location.reload();
  } catch (err) {
    console.log(err.message);
  }
};
export const movetoInventory = async (id, type, dateValue) => {
  const requestObject = {
    inventoryID: id,
    type: type,
    dateValue: dateValue,
  };
  const userToken = localStorage.getItem("user");
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/inventory/updateitem",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(requestObject),
      }
    );
    await response.text();
    window.location.reload();
  } catch (err) {
    console.log(err.message);
  }
};
export const getInventory = async (setFunction) => {
  const userToken = localStorage.getItem("user");
  const hotelID = localStorage.getItem("hotelID");
  const requestObject = {
    hotelID: hotelID,
  };
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/inventory/getitems",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(requestObject),
      }
    );
    const result = await response.json();
    setFunction(result);
    setTimeout(() => {
      getInventory(setFunction);
    }, 5000);
  } catch (err) {
    console.log(err.message);
  }
};
